<template>
    <Trombinoscope 
      Title="UI-UX" 
      :projects="ui_ux_Projects"
      baseRoute="/portfolio/UI-UX"
    />
</template>






<script>


import Trombinoscope from '@/components/Trombinoscope.vue';




export default {
  components:{
    Trombinoscope
  },
  data() {
    return {
      ui_ux_Projects: [
      {  
          nom: 'Bande-Dessinée',
          description: "Bande-dessinée interactive",
          background: '/img/projet/bande-dessinee.jpg',
          skills:['animate.png','illustrator.png'],
          date:"Novembre 2024",
        },
        // { 
        //   nom: 'Marseille.fr',
        //    description: 'Maquette du site web de Marseille sur axure', 
        //    background: '/img/projet/marseille.jpg',
        //    date:"Mars 2024",
        //    skills:['axure.png',]
        //   },
        //   {
        //   nom: 'AccessiWeb',
        //    description: "Maquette axure visant à expliquer tous les rouages de l'accessibilité sur le web",
        //    background: '/img/projet/accessiWeb.jpg',
        //    date:"Avril 2024",
        //    skills:['axure.png',]
        //   },
        //   {
        //   nom: 'ErgoWeb',
        //    description: "Maquette axure traitant de l'ergonomie web", 
        //    background: '/img/projet/ergoWeb.jpg' ,
        //    date:"Décembre 2023",
        //    skills:['axure.png',]
        //   },
        //   {
        //   nom: "Bat'H Game",
        //    description: "Application interactive d'escape game conçue pour le bâtiment H de notre IUT", 
        //    background: '/img/projet/bath.jpg' ,
        //    date:"Mai 2025",
        //    skills: ['flutterflow.png','gdoc.png']
        //   },
      ],
    };
  },
};


</script>




<style scoped>

</style>